import { Suspense, lazy, useContext, useState } from 'react';
import { ObjectPageContext } from '../../pages/Context/ObjectPageContext';
import { BidDto } from '~js/React/services/generatedApi';
import moment from 'moment';
import 'moment/locale/sv';

import { EstateType, StatusId } from '~js/React/Enums';
import BaseTextInfo from './Price/BaseTextInfo';
import ShowHistory from './Price/ShowHistory';
import EconansBtn from './Price/EconansBtn';
import ReadAboutBidding from './Price/ReadAboutBidding';
import ProjectPrice from './Price/ProjectPrice';
import SoldPrice from './Price/SoldPrice';
import StartingPrice from './Price/StartingPrice';
import BiddingPing from './Price/BiddingPing';
import BiddingHistory from './Price/BiddingHistory';

const FinalPriceWatchForm = lazy(
  () => import('../../forms/FinalPriceWatchForm')
);
export default function ObjectPrice() {
  const [historyModal, setHistoryModal] = useState<boolean>(false);
  const [showHideFinalPrice, setShowHideFinalPrice] = useState(false);

  const { objectId, estate, isBigScreen } = useContext(ObjectPageContext);

  const activeBids =
    estate?.bids && estate?.bids.length > 0
      ? estate?.bids.filter(
          (bid: BidDto) => bid.cancelled === false && bid.status === 'Deltar'
        )
      : null;
  moment.locale('sv');

  return (
    <>
      <div
        className={`${
          estate?.bidSetting == 3 &&
          estate?.bids &&
          estate?.status?.id !== StatusId.Sold
            ? 'lg:p-4 lg:pb-1'
            : 'lg:px-4 lg:py-6'
        } flex flex-col my-4 lg:my-0 xxl:px-6 font-ic lg:bg-blue700 lg:text-white`}
      >
        <div className="flex justify-between items-start">
          <div>
            {estate &&
            estate?.status.id != StatusId.Sold &&
            (estate?.bidSetting == 1 ||
              estate?.bidSetting == 2 ||
              estate?.bidSetting == 3) ? (
              <BiddingPing />
            ) : null}

            <div className="flex gap-4 mb-2 lg:mb-3">
              {(estate?.bidSetting == 2 || estate?.bidSetting == 3) &&
              estate?.status.id != StatusId.Sold ? (
                <>
                  {estate?.bids?.length ? (
                    <BaseTextInfo text={`Högsta bud`} />
                  ) : null}
                  {!estate?.bids?.length && (
                    <BaseTextInfo
                      text={`${
                        estate?.priceInfo?.text
                          ? estate?.priceInfo?.text.charAt(0).toUpperCase() +
                            estate?.priceInfo?.text.slice(1)
                          : 'Utgångspris'
                      }`}
                    />
                  )}
                </>
              ) : null}
              {estate?.priceInfo?.priceMin &&
              estate?.priceInfo?.priceMax &&
              estate?.estateTypeAsString == EstateType.Project ? (
                <BaseTextInfo text={`Pris`} />
              ) : null}
              {estate?.estateTypeAsString != EstateType.Project &&
              estate?.bidSetting != 2 &&
              estate?.bidSetting != 3 &&
              estate?.priceInfo?.startPrice != 0 &&
              estate?.status.id != StatusId.Sold ? (
                <BaseTextInfo
                  text={`${
                    estate?.priceInfo?.text
                      ? estate?.priceInfo?.text.charAt(0).toUpperCase() +
                        estate?.priceInfo?.text.slice(1)
                      : 'Utgångspris'
                  }`}
                />
              ) : null}

              {/* SÅLT OBJEKT */}
              {estate?.status.id == StatusId.Sold ? (
                <BaseTextInfo
                  text={`${
                    estate?.priceInfo?.finalPrice ? 'Slutpris' : 'Utgångspris'
                  }`}
                />
              ) : null}
              {estate?.status.id != StatusId.Sold &&
              !estate?.isHeadStart &&
              estate?.estateTypeAsString !== EstateType.Project &&
              estate?.estateTypeAsString !== EstateType.Commercial ? (
                <button
                  onClick={(e) => {
                    setShowHideFinalPrice(true);
                  }}
                >
                  <span className="text-base font-ic underline">
                    Bevaka slutpris
                  </span>
                </button>
              ) : null}
            </div>

            <h2 className="text-4xl lg:text-3xl xl:text-4xl font-lf text-blue700 lg:text-white leading-8 my-2">
              {(estate?.bidSetting == 2 || estate?.bidSetting == 3) &&
              estate?.status.id != StatusId.Sold ? (
                <>
                  {estate?.bids &&
                  estate?.bids?.length > 0 &&
                  activeBids &&
                  activeBids[0] ? (
                    <span>
                      {activeBids[0]?.amount
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                      kr
                    </span>
                  ) : null}
                  {(!estate?.bids || estate?.bids?.length == 0) &&
                  estate?.priceInfo.startPrice ? (
                    <span>
                      {estate?.priceInfo.startPrice
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                      kr
                    </span>
                  ) : null}
                </>
              ) : null}
              {estate?.bidSetting !== 2 &&
              estate?.bidSetting !== 3 &&
              estate?.status.id != StatusId.Sold &&
              estate?.priceInfo?.startPrice != 0 &&
              estate?.priceInfo?.startPrice != null ? (
                <span>
                  {estate?.priceInfo.startPrice
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                  kr
                </span>
              ) : null}
              {estate?.priceInfo?.priceMin &&
              estate?.priceInfo?.priceMax &&
              estate?.estateTypeAsString == EstateType.Project ? (
                <ProjectPrice />
              ) : null}
              {estate?.status.id == StatusId.Sold ? <SoldPrice /> : null}
              {estate?.status.id != StatusId.Sold &&
                !estate?.priceInfo?.priceMin &&
                !estate?.priceInfo?.priceMax &&
                (!estate?.priceInfo.startPrice ||
                  estate?.priceInfo.startPrice == 0) &&
                estate?.bidSetting !== 3 &&
                estate?.bidSetting !== 2 && (
                  <span className="text-3xl lg:text-2xl xxl:text-3xl font-lf text-blue700 lg:text-white leading-8">
                    Pris ej angivet
                  </span>
                )}
            </h2>
            {estate?.status.id == StatusId.Sold && estate?.movingIn && (
              <p className="my-0 mt-2 xxl:mt-4">
                Såld:{' '}
                {moment(estate.movingIn, 'DD-MM-YYYY').format('YYYY-MM-DD')}
              </p>
            )}

            {estate?.priceInfo.startPrice != 0 &&
            estate?.priceInfo.startPrice !== null &&
            (estate?.bidSetting == 2 || estate?.bidSetting == 3) &&
            estate?.bids[0] &&
            estate?.status.id != StatusId.Sold ? (
              <StartingPrice />
            ) : null}
          </div>
        </div>
        {(estate?.bidSetting == 1 ||
          estate?.bidSetting == 2 ||
          estate?.bidSetting == 3) &&
        estate?.status.id != StatusId.Sold ? (
          <ReadAboutBidding />
        ) : null}
        {estate?.bidSetting === 3 &&
        estate?.bids &&
        estate?.status?.id !== StatusId.Sold ? (
          <div className="border-2 border-blue700 rounded-md my-4 lg:my-0">
            <button
              onClick={(e) => {
                if (historyModal === false) {
                  setHistoryModal(true);
                } else {
                  setHistoryModal(false);
                }
              }}
              className="lg:text-white text-blue700 font-icb lg:mt-2 lg:mb-0 w-full items-center justify-center mx-auto bidding-history-btn"
            >
              {estate?.bidSetting == 3 && (
                <ShowHistory historyModal={historyModal} />
              )}
            </button>
            {historyModal && <BiddingHistory />}
          </div>
        ) : null}
      </div>
      {estate?.econansReady && isBigScreen && <EconansBtn />}
      {showHideFinalPrice && (
        <Suspense>
          <FinalPriceWatchForm
            setShowHideModalFunction={setShowHideFinalPrice}
            estateAddress={estate?.addressInfo?.streetAddress}
            estateId={objectId}
            customerId={estate?.customerId}
          ></FinalPriceWatchForm>
        </Suspense>
      )}
    </>
  );
}
